module.exports = __webpack_public_path__ + "img/fananzxbg_sample.acde22b3.png";